const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2021 - 2025",
    title: "Bachelor's in Information Technology",
    desc: "Pursuing a comprehensive degree focusing on software development, database systems, computer networks, cybersecurity, and project management at a reputed university.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - 2021",
    title: "F.Sc. Pre-Engineering",
    desc: "Completed intermediate education with a strong foundation in mathematics, physics, and chemistry, developing critical analytical and problem-solving skills.",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2017 - 2019",
    title: "Matriculation – Science",
    desc: "Achieved solid academic performance with a focus on computer science and foundational science subjects, laying the groundwork for a tech-focused academic path.",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2022 - Present",
    title: "Front-End Developer",
    desc: "Developing responsive and user-friendly interfaces using React, HTML, CSS, and JavaScript. Collaborating with design teams to bring UI/UX concepts to life in live projects.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2023 - Present",
    title: "Back-End Developer",
    desc: "Building and maintaining RESTful APIs and backend logic using Node.js and Express. Working with databases like MongoDB and MySQL to ensure robust and secure data management.",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - Present",
    title: "UI/UX Designer",
    desc: "Designing user-centric interfaces and improving user journeys using tools like Figma and Adobe Photoshop. Creating wireframes, prototypes, and design systems for web and mobile apps.",
  },
];

export default Data;